import './page.scss';

// Sections
import '@/sections/blog-article-main/blog-article-main';
import '@/sections/related-blog-articles/related-blog-articles';
